import * as React from "react";
import {
  styled,
  Theme,
  CSSObject,
  useTheme,
  alpha,
} from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useLocation, useNavigate } from "react-router-dom";
import { menuConfig, menuList } from "./config";
import dashboardicon from "../../../assets/Images/dashboard.png";
import accountowner from "../../../assets/Images/accountowner.png";
import billingandpayment from "../../../assets/Images/billingandpayment.png";
import crm from "../../../assets/Images/crm.png";
import subscription from "../../../assets/Images/subscription.png";
import termsandcondition from "../../../assets/Images/termsandcondition.png";
import emailcampaign from "../../../assets/Images/emailcampaign.png";
import BillingIcon from "../../../assets/Images/Billing.png";
import { GrSend } from "react-icons/gr";
import {
  AppBar,
  Avatar,
  Box,
  Button,
  Divider,
  InputAdornment,
  Menu,
  MenuItem,
  SwipeableDrawer,
  Toolbar,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Switch,
} from "@mui/material";
import RILogo from "../../../assets/Images/Logo.jpg";
import MenuImg from "../../../assets/Images/MenuIcon.png";
import closedlogo from "../../../assets/Images/revenue_logo.jpg";
import InputBase from "@mui/material/InputBase";
// import SearchIcon from '@mui/icons-material/Search';
// import { RIHeader } from '../header';
import { RISearch } from "../searchFilter/RISearch";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import calender from "../../../assets/Images/calender.png";
import profileimg from "../../../assets/Images/profileimg.png";
import { useState, useEffect } from "react";
import Searching from "../../../assets/Images/Search.png";
import CloseIcon from "@mui/icons-material/Close";
import NotificationsIcon from "@mui/icons-material/Notifications";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
// import TuneIcon from '@mui/icons-material/Tune';
// import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import LogoutIcon from "@mui/icons-material/Logout";
import relation from "../../../assets/Images/relationship.png";
import "./Menu.scss";
import { MdOutlineSubscriptions } from "react-icons/md";
import { FaFileAlt } from "react-icons/fa";
import { FaUser } from "react-icons/fa";
import { FaUsers } from "react-icons/fa6";
import Swal from "sweetalert2";

// import organizationicon from '../../../assets/images/imgpsh_fullsize_anim (1).png'
// import rolesicon from '../../../assets/images/imgpsh_fullsize_anim (5).png'
// import plansicon from '../../../assets/images/imgpsh_fullsize_anim (6).png'
// import integrationsicon from '../../../assets/images/imgpsh_fullsize_anim (9).png'

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
}));

const StyledInputBase2 = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  borderRadius: "20px",
  backgroundColor: " #F0F3F6",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(1)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "11ch",
    },
  },
}));

export const RIMenu = () => {
  const [open, setOpen] = React.useState(true);
  const [mobileopen, setMobileopen] = useState(false);
  const [menus, setMenus] = React.useState([]);
  const [isAll, setIsAll] = React.useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [username, setUsername] = useState("");

    const baseURL =
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;

  const handleClick = () => {
    setIsClicked(true);
  };

  const [role, setRole] = useState("");

  useEffect(() => {
    const userRole = localStorage.getItem("role");
    setRole(userRole);
  }, []);

   useEffect(() => {
    const storedUser = localStorage.getItem("userData");
    if (storedUser) {
      setUserData(JSON.parse(storedUser));
    }
  }, []);

  useEffect(() => {
    const storedName = localStorage.getItem("name");
    if (storedName) {
      setUsername(storedName);
    }
  }, []);

  const handlemobileDrawerOpen = () => {
    setMobileopen((prevOpen) => !prevOpen);
  };

  const handleDrawerClose = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const navigate = useNavigate();

  const [currentDateTime, setCurrentDateTime] = useState(new Date());

  const formatDate = (date) => {
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const formatter = new Intl.DateTimeFormat("en-IN", options);

    const parts = formatter.formatToParts(date);
    const dayPart = parts.find((part) => part.type === "day");
    const monthPart = parts.find((part) => part.type === "month");
    const yearPart = parts.find((part) => part.type === "year");

    const day = dayPart ? dayPart.value : "";
    const month = monthPart ? monthPart.value : "";
    const year = yearPart ? yearPart.value : "";

    const formattedDate = `${day}${getOrdinalIndicator(day)} ${month}, ${year}`;
    return formattedDate;
  };

  const getOrdinalIndicator = (day) => {
    const suffixes = {
      1: "st",
      2: "nd",
      3: "rd",
    };

    const lastDigit = parseInt(day) % 10;
    const suffix = suffixes[lastDigit] || "th";
    return suffix;
  };

  const getCurrentTime = () => {
    return new Date()
      .toLocaleTimeString("en-IN", {
        timeZone: "Asia/Kolkata",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .toUpperCase();
  };

  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [userData, setUserData] = React.useState({});
  const [activeMenu, setActiveMenu] = useState("");

  // Function to handle menu item click and update the activeMenu state
  const handleMenuItemClick = (menu) => {
    setActiveMenu(menu);
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const logOutUser = (e) => {
    e.preventDefault();
    handleMenuClose();
  Swal.fire({
    icon: "warning",
    title: "Are you sure you want to logout?",
    showCancelButton: true,
    confirmButtonColor: "#FCB124",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, Logout",
    cancelButtonText: "Cancel"
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        const token = localStorage.getItem("token");

        await fetch(`${baseURL}/api/logout`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        });

        localStorage.clear();
        window.location.href = "/";
      } catch (error) {
        console.error("Logout failed:", error);
        Swal.fire("Error", "Logout failed. Try again.", "error");
      }
    }
  });
};

  const handleOpenAccount = () =>{
    navigate('/userprofile')
    handleMenuClose();
  }

  const StyledTypography = styled(Typography)`
    background-color: #edf0f5;
    height: 30px;
    width: 220px;
    padding: 5px;
    padding-right: -20px;
    color: black;
    margin-right: 30px;
    font-size: 16px;
    border-radius: 15px;
  `;

  let location = useLocation();

  const [salessearchopen, setSalessearchopen] = useState(false);
  const handlesalessearch = () => {
    setSalessearchopen(!salessearchopen);
  };

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        {["Inbox", "Starred", "Send email", "Drafts"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {["All mail", "Trash", "Spam"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <AppBar
        id="test"
      >
        <Toolbar>
          <IconButton
            id="drawer-open-icon"
            aria-label="open drawer"
            onClick={handleDrawerClose}
            edge="start"
            sx={{
              marginRight: 3,
              ...(open && {
                display: "flex",
                color: "black",
                paddingLeft: "10%",
              }),
            }}
          >
            <ArrowForwardIcon />
          </IconButton>
          <Typography
            sx={{ flexGrow: 1 }}
            id={open ? "logo-line2" : "logo-line"}
          >
            <span
              className="welcome"
              style={{
                fontSize: "2.5vmin",
                cursor: "pointer",
                color: "black",
                ...(open && { marginLeft: "10%", paddingLeft: "2%" }),
              }}
            >
               Welcome back, <b>{username && username.split("_").join(" ")}!</b>
            </span>
          </Typography>
          <div id="search">
            <RISearch></RISearch>
          </div>

          <div className="time-date-div">
            <img
              src={calender}
              style={{
                height: "20px",
                width: "20px",
                color: "orange",
                verticalAlign: "middle",
                marginRight: "5px",
              }}
              alt="calendar icon"
            />
            {getCurrentTime()} | {formatDate(new Date())}
          </div>

          <Box
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={handleMenuClick}
            style={{
              display: "flex",
              flexDirection: "row",
              height: "100%",
              alignItems: "center",
              justifyContent: "center",
              margin: "auto",
              cursor: "pointer",
            }}
          >
            <IconButton sx={{ p: 0, mr: 1 }}>
              <Avatar
                id="avatar"
                sx={{ height: "90%", width: "90%" }}
                alt="Remy Sharp"
                src={profileimg}
              />
            </IconButton>
            <div>
              <p
                id="name"
                style={{
                  fontSize: "1.8vmin",
                  lineHeight: "1.5vmin",
                  color: "black",
                  fontWeight: "bold",
                }}
              >
                {userData.user_name && userData.user_name.split("_").join(" ")}
              </p>
              <p
                id="name"
                style={{
                  fontSize: "1.8vmin",
                  lineHeight: "1.5vmin",
                  marginTop: "0px",
                  color: "rgba(39, 39, 39, 0.6)",
                }}
              >
                {userData.role && userData.role.role_name}
              </p>
            </div>
          </Box>
          <Menu
            id="simple-menu"
            style={{ marginTop: "3.5%" }}
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ horizontal: "center", vertical: "bottom" }}
            keepMounted
          >
            <MenuItem style={{ justifyContent: "center" }} onClick={logOutUser}>
              Logout
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      <AppBar
        id="mobileview-test"
        style={{
          backgroundColor: "#FCFCFC",
          height: "9vh",
          width: "96%",
          marginLeft: "9%",
          boxShadow: "none",
          borderBottom: "0.2px solid rgba(0, 0, 0, 0.5)",
        }}
      >
        <Toolbar className="mobile-view-toolbar">
          <div className="mobile-view-logobar">
            <IconButton
              className="mobile-menu-icon"
              id="drawer-open-icon"
              aria-label="open drawer"
              onClick={handlemobileDrawerOpen}
              edge="start"
              sx={{
                marginRight: 3,
                display: "flex",
                color: "black",
              }}
            >
              <MenuIcon
                id="menu-icon"
                style={{
                  cursor: "pointer",
                  color: "black",
                  fontSize: "24px",
                  marginLeft: "10px",
                }}
              />
            </IconButton>
            {!salessearchopen ? (
              <div className="logo-wrap">
                <img className="logo" src={RILogo} />
              </div>
            ) : null}
            <div className="icons-box">
              {!salessearchopen ? (
                <IconButton>
                  <NotificationsIcon />
                </IconButton>
              ) : null}
              {!salessearchopen ? (
                <img
                  onClick={handlesalessearch}
                  src={Searching}
                  id="icons"
                  style={{
                    alignItems: "flex-end",
                    fontSize: "2vmin",
                    height: "25px",
                    cursor: "pointer",
                  }}
                />
              ) : null}
              {salessearchopen ? (
                <Search className="card-search">
                  <StyledInputBase2
                    placeholder="Search here"
                    inputProps={{ "aria-label": "search" }}
                    endAdornment={
                      <InputAdornment position="end">
                        <CloseIcon
                          onClick={handlesalessearch}
                          style={{
                            marginRight: "5px",
                            cursor: "pointer",
                            color: "rgba(0, 0, 0, 0.5)",
                          }}
                        />
                      </InputAdornment>
                    }
                  />
                </Search>
              ) : null}
            </div>
          </div>
          <div className="name-time-wrap">
            <Typography sx={{ flexGrow: 1 }} id="logo-line">
              <span
                className="welcome"
                style={{
                  fontSize: "1vmin",
                  cursor: "pointer",
                  color: "black",
                  ...(open && { marginLeft: "22%" }),
                }}
              >
                Welcome back,
                <b>
                  {userData.user_name &&
                    userData.user_name.split("_").join(" ")}{" "}
                  !{" "}
                </b>
              </span>
            </Typography>
            <div className="time-date-div">
              <img
                src={calender}
                style={{
                  height: "20px",
                  width: "20px",
                  color: "orange",
                  verticalAlign: "middle",
                  marginRight: "5px",
                }}
              />
              {currentDateTime.toLocaleString()}
            </div>
          </div>
        </Toolbar>
      </AppBar>
      {/* sidebar */}
      <Drawer id="menu" variant="permanent" open={open}>
        <List className="side-list-wrap" style={{ backgroundColor: "white" }}>
          <DrawerHeader
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-evenly",
              height: "9%",
              width: "100%",
            }}
          >
            {open ? (
              <img
                style={{
                  height: "70%",
                  width: "70%",
                  justifyContent: "start",
                  objectFit: "contain",
                }}
                src={RILogo}
                onClick={() => navigate("/dashboard")}
              />
            ) : (
              <img
                id="logo"
                style={{
                  height: "40px",
                  width: "35px",
                  color: "black",
                  justifyContent: "center",
                }}
                src={closedlogo}
              />
            )}
            {/* <MenuIcon onClick={handleDrawerClose} id="menu-icon" style={{ cursor: 'pointer', color: 'black', fontSize: '23px', marginTop: '-30px', paddingTop: '10%', right: '5%', ...(!open && { display: 'none' }) }} /> */}
            <img
              src={MenuImg}
              onClick={handleDrawerClose}
              id="menu-icon"
              style={{
                cursor: "pointer",
                color: "black",
                ...(!open && { display: "none" }),
              }}
            />
          </DrawerHeader>
          <ListItem disablePadding className="menu-wrap">
            <span
              style={{
                letterSpacing: "2px",
                marginLeft: "5px",
                ...(!open && { marginLeft: "1px" }),
              }}
            >
              MENU
            </span>
            {role === "user" && (
              <div>
                <ListItemButton
                  onClick={() => navigate("/dashboard")}
                  style={{
                    backgroundColor:
                      location.pathname.indexOf("/dashboard") === -1
                        ? ""
                        : "#FCB124",
                  }}
                  className="lst-btn"
                  sx={{
                    minHeight: 20,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 1 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    {/* <img src={dashboardicon} alt="dashboard" className='img-icon' /> */}
                    <img
                      style={{ height: "25px", width: "25px", filter: "none" }}
                      tabIndex={0}
                      src={dashboardicon}
                      alt="dashboardicon"
                      onClick={handleClick}
                      className="img-icon"
                    />
                  </ListItemIcon>
                  <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                    <span className="menu-txt">Dashboard</span>
                  </ListItemText>
                </ListItemButton>
                <ListItemButton
                  onClick={() => navigate("/accountowner")}
                  style={{
                    backgroundColor:
                      location.pathname.indexOf("/accountowner") === -1
                        ? ""
                        : "#FCB124",
                  }}
                  className="lst-btn"
                  sx={{
                    minHeight: 20,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 1 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      style={{ height: "25px", width: "25px", filter: "none" }}
                      tabIndex={0}
                      src={accountowner}
                      alt="dashboardicon"
                      onClick={handleClick}
                      className="img-icon"
                    />
                  </ListItemIcon>
                  <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                    <span className="menu-txt">Account Owner</span>
                  </ListItemText>
                </ListItemButton>
                <ListItemButton
                  onClick={() => navigate("/crm")}
                  style={{
                    backgroundColor:
                      location.pathname.indexOf("/crm") === -1 ? "" : "#FCB124",
                  }}
                  className="lst-btn"
                  sx={{
                    minHeight: 20,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 1 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    {/* <img src={relation} alt="dashboard" className='img-icon' />  */}
                    <img
                      style={{ height: "25px", width: "25px", filter: "none" }}
                      tabIndex={0}
                      src={crm}
                      alt="billing"
                      onClick={handleClick}
                      className="img-icon"
                    />
                  </ListItemIcon>
                  <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                    <span className="menu-txt">CRM</span>
                  </ListItemText>
                </ListItemButton>
                <ListItemButton
                  onClick={() => navigate("/mail")}
                  style={{
                    backgroundColor:
                      location.pathname.indexOf("/mail") === -1
                        ? ""
                        : "#FCB124",
                  }}
                  className="lst-btn"
                  sx={{
                    minHeight: 20,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 1 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    {/* <img style={{ height: '25px', width: '25px', filter: 'none' }} tabIndex={0} src={emailcampaign} alt='billing' onClick={handleClick} className='img-icon' /> */}
                    <GrSend style={{ fontSize: "22px" }} />
                  </ListItemIcon>
                  <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                    <span className="menu-txt">Email Campaign</span>
                  </ListItemText>
                </ListItemButton>

                <ListItemButton
                  onClick={() => navigate("/billingandpayment")}
                  style={{
                    backgroundColor:
                      location.pathname.indexOf("/billingandpayment") === -1
                        ? ""
                        : "#FCB124",
                  }}
                  className="lst-btn"
                  sx={{
                    minHeight: 20,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 1 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    {/* <img src={dashboardicon} alt="dashboard" className='img-icon' /> */}
                    <img
                      style={{ height: "25px", width: "25px", filter: "none" }}
                      tabIndex={0}
                      src={billingandpayment}
                      alt="billing"
                      onClick={handleClick}
                      className="img-icon"
                    />
                  </ListItemIcon>
                  <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                    <span className="menu-txt">Billing & Payments</span>
                  </ListItemText>
                </ListItemButton>
                <ListItemButton
                  onClick={() => navigate("/subscription")}
                  style={{
                    backgroundColor:
                      location.pathname.indexOf("/subscription") === -1
                        ? ""
                        : "#FCB124",
                  }}
                  className="lst-btn"
                  sx={{
                    minHeight: 20,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 1 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    {/* <img src={dashboardicon} alt="dashboard" className='img-icon' /> */}
                    <img
                      style={{ height: "25px", width: "25px", filter: "none" }}
                      tabIndex={0}
                      src={subscription}
                      alt="dashboardicon"
                      onClick={handleClick}
                      className="img-icon"
                    />
                  </ListItemIcon>
                  <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                    <span className="menu-txt">Subscription</span>
                  </ListItemText>
                </ListItemButton>
                <ListItemButton
                  onClick={() => navigate("/termsandconditions")}
                  style={{
                    backgroundColor:
                      location.pathname.indexOf("/termsandconditions") === -1
                        ? ""
                        : "#FCB124",
                  }}
                  className="lst-btn"
                  sx={{
                    minHeight: 20,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 1 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      style={{ height: "25px", width: "25px", filter: "none" }}
                      tabIndex={0}
                      src={termsandcondition}
                      alt="billing"
                      onClick={handleClick}
                      className="img-icon"
                    />
                  </ListItemIcon>
                  <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                    <span className="menu-txt">Terms and Conditions</span>
                  </ListItemText>
                </ListItemButton>
              </div>
            )}
            {role === "admin" && (
              <div>
                <ListItemButton
                  onClick={() => navigate("/user-management")}
                  style={{
                    backgroundColor:
                      location.pathname.indexOf("/user-management") === -1
                        ? ""
                        : "#FCB124",
                  }}
                  className="lst-btn"
                  sx={{
                    minHeight: 20,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 1 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    {/* <img src={dashboardicon} alt="dashboard" className='img-icon' /> */}
                    <FaUser
                      style={{ fontSize: "18px" }}
                      tabIndex={0}
                      alt="billing"
                      onClick={handleClick}
                      className="img-icon"
                    />
                  </ListItemIcon>
                  <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                    <span className="menu-txt">User Management</span>
                  </ListItemText>
                </ListItemButton>
                <ListItemButton
                  onClick={() => navigate("/billingandpayment")}
                  style={{
                    backgroundColor:
                      location.pathname.indexOf("/billingandpayment") === -1
                        ? ""
                        : "#FCB124",
                  }}
                  className="lst-btn"
                  sx={{
                    minHeight: 20,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 1 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    {/* <img src={dashboardicon} alt="dashboard" className='img-icon' /> */}
                    <img
                      style={{ height: "25px", width: "25px", filter: "none" }}
                      tabIndex={0}
                      src={BillingIcon}
                      alt="billing"
                      onClick={handleClick}
                      className="img-icon"
                    />
                  </ListItemIcon>
                  <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                    <span className="menu-txt">Billing & Payments</span>
                  </ListItemText>
                </ListItemButton>
                <ListItemButton
                  onClick={() => navigate("/termsandconditions")}
                  style={{
                    backgroundColor:
                      location.pathname.indexOf("/termsandconditions") === -1
                        ? ""
                        : "#FCB124",
                  }}
                  className="lst-btn"
                  sx={{
                    minHeight: 20,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 1 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <FaFileAlt style={{ fontSize: "24px", color: "#000000" }} />
                  </ListItemIcon>
                  <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                    <span className="menu-txt">Terms and Conditions</span>
                  </ListItemText>
                </ListItemButton>
              </div>
            )}
            {isAll &&
              menuList.map((menu) => (
                <ListItemButton
                  onClick={() => navigate(menuConfig[menu].url)}
                  style={{
                    backgroundColor:
                      location.pathname.indexOf(menuConfig[menu].url) === -1
                        ? ""
                        : "#FCB124",
                  }}
                  className="lst-btn"
                  key={menu.menu_name}
                  sx={{
                    minHeight: 40,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 1 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      style={{ height: "23px", width: "28px" }}
                      src={menuConfig[menu].icon}
                    />
                  </ListItemIcon>
                  <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                    <span className="menu-txt">{menuConfig[menu].title}</span>
                  </ListItemText>
                </ListItemButton>
              ))}
            {!isAll &&
              menus.map((menu) => (
                <ListItemButton
                  onClick={() => navigate(menuConfig[menu.menu_name].url)}
                  style={{
                    backgroundColor:
                      location.pathname.indexOf(
                        menuConfig[menu.menu_name].url
                      ) === -1
                        ? ""
                        : "#FCB124",
                  }}
                  className="lst-btn"
                  key={menu.menu_name}
                  sx={{
                    minHeight: 40,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 0 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      style={{ height: "32px", width: "45px" }}
                      src={menuConfig[menu.menu_name].icon}
                    />
                  </ListItemIcon>
                  <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                    <span className="menu-txt">
                      {menuConfig[menu.menu_name].title}
                    </span>
                  </ListItemText>
                </ListItemButton>
              ))}
          </ListItem>
        </List>
      </Drawer>

      <SwipeableDrawer
        anchor="left"
        open={mobileopen}
        onClose={handlemobileDrawerOpen}
        onOpen={handlemobileDrawerOpen}
      >
        <div className="mobile-drawer">
          <List className="side-list-wrap" style={{ backgroundColor: "white" }}>
            <DrawerHeader
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "10%",
              }}
            >
              <img id="logo" src={closedlogo} />
            </DrawerHeader>
            <Box
              aria-controls="simple-menu"
              className="profile-box"
              aria-haspopup="true"
              onClick={handleMenuClick}
              style={{}}
            >
              <IconButton sx={{ p: 0, mr: 1 }}>
                <Avatar
                  id="avatar"
                  sx={{ height: "90%", width: "90%" }}
                  alt="Remy Sharp"
                  src={profileimg}
                />
              </IconButton>
              <div>
                <p
                  id="name"
                  style={{
                    fontSize: "1.8vmin",
                    lineHeight: "1.5vmin",
                    color: "black",
                    fontWeight: "bold",
                  }}
                >
                  {userData.user_name &&
                    userData.user_name.split("_").join(" ")}
                </p>
                <p
                  id="name"
                  style={{
                    fontSize: "1.8vmin",
                    lineHeight: "1.5vmin",
                    marginTop: "0px",
                    color: "rgba(39, 39, 39, 0.6)",
                  }}
                >
                  {userData.role && userData.role.role_name}
                </p>
              </div>
            </Box>
            <Menu
              id="simple-menu"
              style={{ marginTop: "3.5%" }}
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              transformOrigin={{ horizontal: "center", vertical: "bottom" }}
            >
              {/* <MenuItem style={{ justifyContent: "center" }} onClick={handleMenuClose}>Settings</MenuItem>
                            <MenuItem style={{ justifyContent: "center" }} onClick={handleMenuClose}>Account</MenuItem> */}
              <MenuItem
                style={{ justifyContent: "center" }}
                onClick={handleOpenAccount}
              >
                Account
              </MenuItem>

              <MenuItem
                style={{ justifyContent: "center" }}
                onClick={logOutUser}
              >
                Logout
              </MenuItem>
            </Menu>

            <ListItem className="menu-wrap">
              <ListItemButton
                onClick={() => navigate("/dashboard")}
                style={{
                  backgroundColor:
                    location.pathname.indexOf("/dashboard") === -1
                      ? ""
                      : "#FCB124",
                }}
                className="lst-btn"
                sx={{
                  minHeight: 20,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 1 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <img
                    style={{ height: "30px", width: "38px" }}
                    src={dashboardicon}
                  />
                </ListItemIcon>
                <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                  <span className="menu-txt">Dashboard</span>
                </ListItemText>
              </ListItemButton>

              {isAll &&
                menuList.map((menu) => (
                  <ListItemButton
                    onClick={() => navigate(menuConfig[menu].url)}
                    style={{
                      backgroundColor:
                        location.pathname.indexOf(menuConfig[menu].url) === -1
                          ? ""
                          : "#FCB124",
                    }}
                    className="lst-btn"
                    key={menu.menu_name}
                    sx={{
                      minHeight: 40,
                      justifyContent: "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 1 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        style={{ height: "32px", width: "38px" }}
                        src={menuConfig[menu].icon}
                      />
                    </ListItemIcon>
                    <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                      <span className="menu-txt">{menuConfig[menu].title}</span>
                    </ListItemText>
                  </ListItemButton>
                ))}
              {!isAll &&
                menus.map((menu) => (
                  <ListItemButton
                    onClick={() => navigate(menuConfig[menu.menu_name].url)}
                    style={{
                      backgroundColor:
                        location.pathname.indexOf(
                          menuConfig[menu.menu_name].url
                        ) === -1
                          ? ""
                          : "#FCB124",
                    }}
                    className="lst-btn"
                    key={menu.menu_name}
                    sx={{
                      minHeight: 40,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 0 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        style={{ height: "32px", width: "45px" }}
                        src={menuConfig[menu.menu_name].icon}
                      />
                    </ListItemIcon>
                    <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                      <span className="menu-txt">
                        {menuConfig[menu.menu_name].title}
                      </span>
                    </ListItemText>
                  </ListItemButton>
                ))}
              <Divider
                style={{
                  width: "96%",
                  marginLeft: "2%",
                  height: "2%",
                  color: "rgba(0, 0, 0, 0.5)",
                }}
              />
            </ListItem>
            <ListItem className="menu-wrap2">
              <ListItemButton
                onClick={() => navigate("/dashboard")}
                className="lst-btn"
                sx={{
                  minHeight: 20,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 1 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <LogoutIcon style={{ height: "25px", width: "36px" }} />
                  {/* <img src={dashboardicon} /> */}
                </ListItemIcon>
                <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                  <span className="menu-txt">Logout</span>
                </ListItemText>
              </ListItemButton>
            </ListItem>
          </List>
        </div>
      </SwipeableDrawer>
    </>
  );
};
